export class Paginado {
    email: string;
    numeroPagina: number;
    fechaInicio?:string;
    fechaFin?: string;
    termino?:string;
    rolUserlogin?:number;
    orderByArea?:boolean;
    orderByGeneral?:boolean;
    orderBySubse?:boolean;
    botonBuscar?:boolean;
    folio_iniciativa?:string;
    idSubsecretariaSap?:number;
    idLider?:number;
    idEnlace?:number;
    idTipoSolicitud?:number;
    idAplicacion?:number;
    id_dirgralSap?:number;
    listEstatus?:number[];
    fechaEnvio_iniciativa?:string;
    idRol_enlace?:number;
    idRol_lider?:number;
    idGestorCambios ?:number;
    idAnalistaTI  ?:number;
}

export class PaginadoAdiminstrador {
    opcion?: number;
    fechaInicio?: string;
    fechaFin?: string;
    numeroPagina: number;
    folio?: number;
    idUsuario?: number;
    estatus?: number;
    email?: string;
    termino?:string;
    orderByGeneral?:boolean;
    idGestorCambios ?:number;
    idAnalistaTI  ?:number;



}
export class PaginadoLider {
    opcion?: number;
    fechaInicio?: Date;
    fechaFin?: Date;
    numeroPagina: number;
    folio?: number;
    email?: string;
    estatus?: number;
    termino?:string;
}


export class PaginadoReportes {
    fechaInicio?: string;
    fechaFin?: string;
    numeroPagina: number;
    email?: string;
}

